<div class="mb-8 flex items-center justify-between">
  <h1 class="flex h-11 items-center text-2xl font-bold text-aux-gray-darkest">Dashboard</h1>
  <!--<div class="flex space-x-2"></div>-->
</div>

<div class="mb-5 rounded border p-4">
  <div class="mb-4 text-xl font-bold text-black">Notifications and Alerts</div>

  <div class="mb-4 flex space-x-4 text-xs">
    <aux-checkbox [id]="'all'" [checked]="true">All</aux-checkbox>
    <aux-checkbox [id]="'risk_flags'">Risk Flags</aux-checkbox>
    <aux-checkbox [id]="'change_management'">Change Management</aux-checkbox>
    <aux-checkbox [id]="'tasks'">Tasks</aux-checkbox>
    <aux-checkbox [id]="'financial'">Financial</aux-checkbox>
  </div>

  @for (alert of alerts; track alert) {
    <div class="my-2 grid grid-cols-12 items-center rounded border p-6">
      <div class="col-span-3">
        <div class="text-xs">{{ alert.date }}</div>
        <div class="text-sm font-bold text-aux-black">{{ alert.header }}</div>
      </div>
      <div class="col-span-9 flex items-center justify-between">
        <div class="text-sm text-aux-black" [innerHTML]="alert.html"></div>
        <aux-icon name="X" />
      </div>
    </div>
  }

  <div class="flex items-center justify-center text-sm text-aux-blue">
    Expand All
    <aux-icon name="ChevronDown" class="text-aux-blue" />
  </div>
</div>

<div class="grid grid-cols-3 gap-5">
  <div class="overflow-hidden rounded border border-aux-gray-dark p-4">
    <div class="mb-4 text-xl font-bold text-aux-black">
      Work Performed, by Trial/Vendor Contract
    </div>
    <div class="space-y-4">
      @for (timeline of timelineData; track timeline) {
        <ng-container
          [ngTemplateOutlet]="progress"
          [ngTemplateOutletContext]="{
            config: timeline,
          }"
        />
      }
    </div>
  </div>
  <div class="overflow-hidden rounded border border-aux-gray-dark p-4">
    <div class="mb-4 text-xl font-bold text-aux-black">Change Log Summary</div>

    <div class="flex text-xs">
      @if (percentage > 0) {
        <div
          class="flex h-5 items-center justify-end rounded-l pr-8"
          [ngClass]="{
            'bg-aux-blue': percentage <= 100,
            'bg-aux-error': percentage > 100,
          }"
          [ngStyle]="{ width: (percentage > 100 ? 100 : percentage) + '%' }"
        >
          @if (percentage > 20) {
            <span class="text-white">(%{{ percentage }})</span>
          }
        </div>
      }
      <div
        class="flex h-5 items-center rounded-r bg-aux-blue-light pl-4"
        [ngStyle]="{ width: 100 - (percentage > 100 ? 100 : percentage) + '%' }"
      >
        <span class="text-white">$636,540</span>
      </div>
    </div>

    <div class="mb-4 mt-2 flex space-x-4 text-xs">
      <div class="flex items-center space-x-2">
        <div class="h-4 w-4 rounded-full bg-aux-blue"></div>
        <div>% Unapproved</div>
      </div>
      <div class="flex items-center space-x-2">
        <div class="h-4 w-4 rounded-full bg-aux-blue-light"></div>
        <div>Total Open Change Logs</div>
      </div>
    </div>

    <table class="w-full">
      <thead>
        <tr>
          <th></th>
          <th class="text-center text-xs font-normal text-aux-black">Total CL, $</th>
          <th class="text-center text-xs font-normal text-aux-black">Unapproved, % ($)</th>
        </tr>
      </thead>
      <tbody>
        <tr class="border-b border-aux-gray-light">
          <td class="py-2 text-sm font-medium text-aux-black">Vendor Contract 1</td>
          <td class="text-center text-sm"><strong>$58,000</strong></td>
          <td class="text-center text-sm"><strong></strong></td>
        </tr>
        <tr class="border-b border-aux-gray-light">
          <td class="py-2 text-sm font-medium text-aux-black">Vendor Contract 2</td>
          <td class="text-center text-sm"><strong>$456,000</strong></td>
          <td class="text-center text-sm"><strong></strong></td>
        </tr>
        <tr class="border-b border-aux-gray-light">
          <td class="py-2 text-sm font-medium text-aux-black">Vendor Contract 3</td>
          <td class="text-center text-sm"><strong>$122,540</strong></td>
          <td class="text-center text-sm"><strong>$118,560</strong></td>
        </tr>
      </tbody>
    </table>

    <a href="#" class="mt-2 block text-sm font-medium text-aux-blue underline">See all</a>
  </div>
  <div class="overflow-hidden rounded border border-aux-gray-dark p-4">
    <div class="mb-4 text-xl font-bold text-aux-black">Risk Flags</div>

    <div class="mb-16 mt-8 flex space-x-4 text-xs font-bold">
      <div class="flex items-center space-x-2">
        <div class="h-4 w-4 rounded-full bg-aux-green"></div>
        <div>8 healthy monitors</div>
      </div>
      <div class="flex items-center space-x-2">
        <div class="h-4 w-4 rounded-full bg-aux-error"></div>
        <div>5 flagged monitors</div>
      </div>
    </div>

    <div class="text-sm font-bold">Recently changed monitors</div>

    <div class="mb-4 mt-2 flex flex-col space-y-4 text-xs">
      <div class="flex items-center space-x-2">
        <div class="h-4 w-4 rounded-full bg-aux-green"></div>
        <div>Cash position remains above $1mm</div>
      </div>
      <div class="flex items-center space-x-2">
        <div class="h-4 w-4 rounded-full bg-aux-error"></div>
        <div>Average cost per patient to date exceeds budget by 20%</div>
      </div>
      <div class="flex items-center space-x-2">
        <div class="h-4 w-4 rounded-full bg-aux-error"></div>
        <div>15% of sites with target site efficiency ratio < 3</div>
      </div>
    </div>
  </div>
</div>

<ng-template #progress let-config="config">
  <div>
    <div class="text-sm font-medium text-aux-black">
      {{ config.header }}
    </div>

    <ng-container
      [ngTemplateOutlet]="progressTemplate"
      [ngTemplateOutletContext]="{
        config: config,
      }"
    />

    <!-- <progressbar-->
    <!--   [value]="config.value"-->
    <!--   [max]="100"-->
    <!--   [ngClass]="{-->
    <!--     green: config.progressColor === 'green',-->
    <!--     blue: config.progressColor === 'blue'-->
    <!--   }"-->
    <!--   class="h-1.5 my-2 bg-aux-gray-dark"-->
    <!-- ></progressbar>-->

    <div class="flex items-center justify-between">
      <div class="text-xs text-aux-black">{{ config.leftLabel }}</div>
      <div class="text-xs text-aux-black">{{ config.rightLabel }}</div>
    </div>
  </div>
</ng-template>

<ng-template #progressTemplate let-config="config">
  <div class="relative">
    <div class="my-2 h-1.5 rounded-full bg-aux-gray-dark"></div>
    <div
      class="absolute inset-0 h-1.5 rounded-full"
      [ngClass]="{
        'bg-aux-green': config.progressColor === 'green',
        'bg-aux-blue': config.progressColor === 'blue',
      }"
      [style.width]="config.value + '%'"
    ></div>
  </div>
</ng-template>
